import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import useTransparentHeader from '../../../../../../hooks/ui_hooks/useTransparentHeader';
import { isActivitiesOrDining } from '../../../../../../utilities/planUtils';
import { Animation, Box, Text } from '../../../../../ui-kit';
import { SUMMARY_IMAGES } from '../assets/images';
import {
  CartLogoContainer,
  CartLogoCounter,
  CartLogoImg,
  CartLogoWithAnimation,
  CartMobileSubtotalTopArrow
} from '../styles';

const propTypes = {
  packagesCount: PropTypes.number,
  toggleOpen: PropTypes.func,
  overlayVisible: PropTypes.bool,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool
};

const defaultProps = {
  packagesCount: 0,
  toggleOpen: () => {},
  overlayVisible: false,
  isMobile: false,
  isTablet: false
};

const CartLogo = ({ packagesCount = 0, toggleOpen, overlayVisible, isMobile, isTablet }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const [showArrow, setShowArrow] = useState(true);
  const currentPackageCount = useRef(packagesCount);
  const isTransparentHeader = useTransparentHeader();
  const [aemHeaderSize, setAemHeaderSize] = useState(0);

  const appYPosition = useCallback(() => {
    const headerElement = document.querySelector('.header-container');
    const headerSize = headerElement ? 45 : isMobile ? 58 : 68;
    setShowArrow(window.scrollY <= headerSize);
  }, [isMobile]);

  useEffect(() => {
    appYPosition();
    window.addEventListener('scroll', appYPosition);
    return () => {
      window.removeEventListener('scroll', appYPosition);
    };
  }, [appYPosition]);

  useEffect(() => {
    if (packagesCount > currentPackageCount.current) {
      setShowAnimation(true);
      currentPackageCount.current = packagesCount;
      const closeAnimation = setTimeout(() => {
        setShowAnimation(false);
      }, 1500);

      return () => {
        clearTimeout(closeAnimation);
      };
    } else if (packagesCount !== currentPackageCount.current) {
      currentPackageCount.current = packagesCount;
    }
  }, [packagesCount]);

  useEffect(() => {
    const header = document.querySelector('.header-container__inner-wrapper');
    if (header) {
      const headerSize = header ? header.clientHeight : isMobile ? 58 : 68;
      setAemHeaderSize(headerSize);
    }
  }, [isMobile]);

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleOpen();
    }
  };

  const ariaLabel = packagesCount > 0 ? `Cart, ${packagesCount} item${packagesCount !== 1 ? 's' : ''}` : 'Cart';

  return (
    <CartLogoContainer
      textAlign="center"
      onClick={toggleOpen}
      onKeyDown={handleKeyDown}
      overlayVisible={overlayVisible}
      tabIndex={0}
      role="button"
      aria-label={ariaLabel}>
      <CartLogoImg isTransparentHeader={isTransparentHeader} src={SUMMARY_IMAGES.CART_LOGO} alt="" />
      {isActivitiesOrDining() && showArrow && (isMobile || isTablet) ? (
        <CartMobileSubtotalTopArrow aemHeaderSize={aemHeaderSize} />
      ) : null}
      {packagesCount > 0 ? (
        <CartLogoWithAnimation showAnimation={showAnimation}>
          {showAnimation ? (
            <Box>
              <Animation
                src={SUMMARY_IMAGES.COUNTER_CONFETTI}
                name="CounterConfetti"
                autoplay={true}
                loop={true}
                width={45}
                height={45}
              />
            </Box>
          ) : null}
          <CartLogoCounter>
            <Text fontSize={1} fontWeight="bold" lineHeight={'100%'} color="pureWhite.0">
              {packagesCount}
            </Text>
          </CartLogoCounter>
        </CartLogoWithAnimation>
      ) : null}
    </CartLogoContainer>
  );
};

CartLogo.propTypes = propTypes;
CartLogo.defaultProps = defaultProps;

export default CartLogo;
